import type { WalletCollectionTabOrderId } from '../global/types';

export const SYSTEM_WALLET_COLLECTION_TAB_IDS = {
  my: 'system:my',
  ledger: 'system:ledger',
  view: 'system:view',
} as const satisfies Record<string, WalletCollectionTabOrderId>;

export const REQUIRED_SYSTEM_WALLET_COLLECTION_TAB_IDS: WalletCollectionTabOrderId[] = [
  SYSTEM_WALLET_COLLECTION_TAB_IDS.my,
  SYSTEM_WALLET_COLLECTION_TAB_IDS.view,
];

export function getWalletCollectionTabOrderId(collectionId: string): WalletCollectionTabOrderId {
  return `collection:${collectionId}`;
}

export function normalizeWalletCollectionTabOrder(
  defaultOrderIds: WalletCollectionTabOrderId[],
  storedOrderIds?: WalletCollectionTabOrderId[],
) {
  const validIds = new Set(defaultOrderIds);
  const seenIds = new Set<WalletCollectionTabOrderId>();
  const result: WalletCollectionTabOrderId[] = [];

  for (const id of [...(storedOrderIds ?? []), ...defaultOrderIds]) {
    if (!validIds.has(id) || seenIds.has(id)) continue;
    seenIds.add(id);
    result.push(id);
  }

  return result;
}
